<template>
  <Breadcrumbs
      title="Stock Adjustment"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Stock Adjustment', path: '/stock-adjustment' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <stockAdjustmentForm/>

    </div>
  </div>
</template>


<script>
import stockAdjustmentForm from '@/pages/stock/stock_adjustment/stockAdjustmentForm.vue';

export default {
  components: {
    stockAdjustmentForm
  }
}
</script>